import { LitElement as P, nothing as s, unsafeCSS as F } from "lit";
import { html as m, unsafeStatic as N } from "lit/static-html.js";
import { property as d, query as I } from "lit/decorators.js";
import "@justeattakeaway/pie-button";
import "@justeattakeaway/pie-icon-button";
import { RtlMixin as R, dispatchCustomEvent as h, requiredProperty as j, validPropertyValues as C, defineCustomElement as W } from "@justeattakeaway/pie-webc-core";
import "@justeattakeaway/pie-icons-webc/IconClose";
import "@justeattakeaway/pie-icons-webc/IconChevronLeft";
import "@justeattakeaway/pie-icons-webc/IconChevronRight";
import "@justeattakeaway/pie-spinner";
function Y(n) {
  if (Array.isArray(n)) {
    for (var e = 0, i = Array(n.length); e < n.length; e++)
      i[e] = n[e];
    return i;
  } else
    return Array.from(n);
}
var O = !1;
if (typeof window < "u") {
  var B = {
    get passive() {
      O = !0;
    }
  };
  window.addEventListener("testPassive", null, B), window.removeEventListener("testPassive", null, B);
}
var S = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), g = [], w = !1, L = -1, u = void 0, f = void 0, M = function(e) {
  return g.some(function(i) {
    return !!(i.options.allowTouchMove && i.options.allowTouchMove(e));
  });
}, y = function(e) {
  var i = e || window.event;
  return M(i.target) || i.touches.length > 1 ? !0 : (i.preventDefault && i.preventDefault(), !1);
}, V = function(e) {
  if (f === void 0) {
    var i = !!e && e.reserveScrollBarGap === !0, t = window.innerWidth - document.documentElement.clientWidth;
    i && t > 0 && (f = document.body.style.paddingRight, document.body.style.paddingRight = t + "px");
  }
  u === void 0 && (u = document.body.style.overflow, document.body.style.overflow = "hidden");
}, q = function() {
  f !== void 0 && (document.body.style.paddingRight = f, f = void 0), u !== void 0 && (document.body.style.overflow = u, u = void 0);
}, H = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, U = function(e, i) {
  var t = e.targetTouches[0].clientY - L;
  return M(e.target) ? !1 : i && i.scrollTop === 0 && t > 0 || H(i) && t < 0 ? y(e) : (e.stopPropagation(), !0);
}, K = function(e, i) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!g.some(function(o) {
    return o.targetElement === e;
  })) {
    var t = {
      targetElement: e,
      options: i || {}
    };
    g = [].concat(Y(g), [t]), S ? (e.ontouchstart = function(o) {
      o.targetTouches.length === 1 && (L = o.targetTouches[0].clientY);
    }, e.ontouchmove = function(o) {
      o.targetTouches.length === 1 && U(o, e);
    }, w || (document.addEventListener("touchmove", y, O ? { passive: !1 } : void 0), w = !0)) : V(i);
  }
}, G = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  g = g.filter(function(i) {
    return i.targetElement !== e;
  }), S ? (e.ontouchstart = null, e.ontouchmove = null, w && g.length === 0 && (document.removeEventListener("touchmove", y, O ? { passive: !1 } : void 0), w = !1)) : g.length || q();
};
const X = `*,*:after,*:before{box-sizing:inherit}dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:white;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.1)}._dialog_overlay{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}.c-modal{--modal-size-s: 450px;--modal-size-m: 600px;--modal-size-l: 1080px;--modal-border-radius: var(--dt-radius-rounded-d);--modal-font: var(--dt-font-interactive-l-family);--modal-bg-color: var(--dt-color-container-default);--modal-elevation: var(--dt-elevation-04);border-radius:var(--modal-border-radius);border:none;box-shadow:var(--modal-elevation);font-family:var(--modal-font);background-color:var(--modal-bg-color);padding:0;--modal-margin-none: var(--dt-spacing-none);--modal-margin-small: var(--dt-spacing-g);--modal-margin-large: var(--dt-spacing-j);--modal-margin-block: var(--modal-margin-small);--modal-block-size: fit-content;--modal-inline-size: 75%;--modal-max-block-size: calc(100vh - calc(var(--modal-margin-block) * 2));--modal-max-inline-size: var(--modal-size-m);block-size:var(--modal-block-size);inline-size:var(--modal-inline-size);max-block-size:var(--modal-max-block-size);max-inline-size:var(--modal-max-inline-size)}.c-modal:focus-visible{outline:none}@media (width < 768px){.c-modal pie-icon-button{--btn-dimension: 40px}}.c-modal[open]{display:flex;flex-direction:column}@media (min-width: 768px){.c-modal{--modal-margin-block: var(--modal-margin-large)}}.c-modal[size=small]{--modal-max-inline-size: var(--modal-size-s)}@media (min-width: 768px){.c-modal[size=small]{--modal-margin-block: var(--modal-margin-large)}}.c-modal[size=large]{--modal-inline-size: 75%;--modal-max-inline-size: var(--modal-size-l);--modal-margin-block: var(--modal-margin-large)}@media (width < 768px){.c-modal[size=large],.c-modal[size=medium][isfullwidthbelowmid]{--modal-margin-block: var(--modal-margin-none);--modal-border-radius: var(--dt-radius-rounded-none);--modal-block-size: 100%;--modal-inline-size: 100%;--modal-max-inline-size: 100%}.c-modal[size=large]>.c-modal-scrollContainer,.c-modal[size=medium][isfullwidthbelowmid]>.c-modal-scrollContainer{block-size:100%}}.c-modal[position=top]{margin-block-start:var(--dt-spacing-j);max-block-size:calc(100% - var(--dt-spacing-j) * 2)}@media (width < 768px){.c-modal[position=top][size=large],.c-modal[position=top][isfullwidthbelowmid][size=medium]{margin-block-start:var(--dt-spacing-none);max-block-size:100%}}.c-modal::backdrop{background:rgba(0,0,0,.55)}.c-modal .c-modal-footer{--modal-button-spacing: var(--dt-spacing-d);--modal-footer-padding: var(--dt-spacing-d);display:flex;flex-flow:row-reverse;flex-wrap:wrap;gap:var(--modal-button-spacing);padding:var(--modal-footer-padding)}@media (min-width: 768px){.c-modal .c-modal-footer{--modal-footer-padding: var(--dt-spacing-e)}}@media (width < 768px){.c-modal[hasstackedactions] .c-modal-footer{flex-direction:column}}.c-modal .c-modal-header{display:grid;grid-template-areas:"back heading close";grid-template-columns:minmax(0,max-content) minmax(0,1fr) minmax(0,max-content);align-items:start}.c-modal .c-modal-heading{--modal-header-font-size: calc(var(--dt-font-heading-m-size--narrow) * 1px);--modal-header-font-line-height: calc(var(--dt-font-heading-m-line-height--narrow) * 1px);--modal-header-font-weight: var(--dt-font-heading-m-weight);font-size:var(--modal-header-font-size);line-height:var(--modal-header-font-line-height);font-weight:var(--modal-header-font-weight);margin:0;grid-area:heading;margin-inline-start:var(--dt-spacing-d);margin-inline-end:var(--dt-spacing-d);margin-block:14px}@media (min-width: 768px){.c-modal .c-modal-heading{--modal-header-font-size: calc(var(--dt-font-heading-m-size--wide) * 1px);--modal-header-font-line-height: calc(var(--dt-font-heading-m-line-height--wide) * 1px);margin-inline-start:var(--dt-spacing-e);margin-inline-end:var(--dt-spacing-e);margin-block:20px}}.c-modal[hasbackbutton] .c-modal-heading{margin-inline-start:var(--dt-spacing-b)}@media (min-width: 768px){.c-modal[hasbackbutton] .c-modal-heading{margin-inline-start:var(--dt-spacing-c)}}.c-modal[isdismissible] .c-modal-heading{margin-inline-end:var(--dt-spacing-d)}@media (min-width: 768px){.c-modal[isdismissible] .c-modal-heading{margin-inline-end:var(--dt-spacing-e)}}.c-modal .c-modal-backBtn{grid-area:back;margin-block-start:var(--dt-spacing-b);margin-block-end:var(--dt-spacing-b);margin-inline-start:var(--dt-spacing-b);margin-inline-end:var(--dt-spacing-none)}@media (min-width: 768px){.c-modal .c-modal-backBtn{margin-block-start:var(--dt-spacing-c);margin-block-end:var(--dt-spacing-c);margin-inline-start:var(--dt-spacing-c);margin-inline-end:var(--dt-spacing-none)}}.c-modal .c-modal-closeBtn{grid-area:close;margin-block-start:var(--dt-spacing-b);margin-block-end:var(--dt-spacing-b);margin-inline-start:var(--dt-spacing-none);margin-inline-end:var(--dt-spacing-b)}@media (min-width: 768px){.c-modal .c-modal-closeBtn{margin-block-start:var(--dt-spacing-c);margin-block-end:var(--dt-spacing-c);margin-inline-start:var(--dt-spacing-none);margin-inline-end:var(--dt-spacing-c)}}.c-modal .c-modal-content{--modal-content-font-size: calc(var(--dt-font-size-16) * 1px);--modal-content-font-weight: var(--dt-font-weight-regular);--modal-content-line-height: calc(var(--dt-font-size-16-line-height) * 1px);--modal-content-padding-block: var(--dt-spacing-a);--modal-content-padding-inline: var(--dt-spacing-d);position:relative;min-block-size:var(--dt-spacing-j);font-size:var(--modal-content-font-size);line-height:var(--modal-content-line-height);font-weight:var(--modal-content-font-weight);padding-inline-start:var(--modal-content-padding-inline);padding-inline-end:var(--modal-content-padding-inline);padding-block-start:var(--modal-content-padding-block);padding-block-end:var(--modal-content-padding-block);flex-grow:1}@media (min-width: 768px){.c-modal .c-modal-content{--modal-content-padding-inline: var(--dt-spacing-e)}}.c-modal .c-modal-content--scrollable{background:linear-gradient(to bottom,transparent,var(--dt-color-container-default) 75%) center bottom,linear-gradient(transparent,var(--dt-color-border-strong)) center bottom;background-repeat:no-repeat;background-size:100% 48px,100% 12px;background-attachment:local,scroll}.c-modal>.c-modal-scrollContainer{display:flex;flex-direction:column;overflow-y:auto;--bg-scroll-end: linear-gradient(rgba(255, 255, 255, 0), var(--dt-color-container-default) 70%) 0 100%;--bg-scroll-bottom: radial-gradient(farthest-corner at 50% 100%, rgba(0, 0, 0, .3), rgba(0, 0, 0, 0)) 0 100%;--bg-size-scroll-end: 100% 40px;--bg-size-scroll-bottom: 100% 8px;background:var(--bg-scroll-end),var(--bg-scroll-bottom);background-repeat:no-repeat;background-size:var(--bg-size-scroll-end),var(--bg-size-scroll-bottom);background-attachment:local,scroll}.c-modal>.c-modal-scrollContainer .c-modal-content{flex-shrink:0}.c-modal[isfooterpinned] .c-modal-content{overflow-y:auto}.c-modal[isLoading] .c-modal-content pie-spinner{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.c-modal[isLoading] .c-modal-content .c-modal-contentInner{display:none}@supports not (aspect-ratio: 1/1){.c-modal .c-modal-scrollContainer{background:none}}
`, J = ["h1", "h2", "h3", "h4", "h5", "h6"], Q = ["small", "medium", "large"], Z = ["top", "center"], _ = "pie-modal-close", k = "pie-modal-open", z = "pie-modal-back", ee = "pie-modal-leading-action-click", ie = "pie-modal-supporting-action-click";
var te = Object.defineProperty, oe = Object.getOwnPropertyDescriptor, l = (n, e, i, t) => {
  for (var o = t > 1 ? void 0 : t ? oe(e, i) : e, r = n.length - 1, c; r >= 0; r--)
    (c = n[r]) && (o = (t ? c(e, i, o) : c(o)) || o);
  return t && o && te(e, i, o), o;
};
const v = "pie-modal";
class a extends R(P) {
  constructor() {
    super(...arguments), this.headingLevel = "h2", this.hasBackButton = !1, this.hasStackedActions = !1, this.isDismissible = !1, this.isFooterPinned = !0, this.isFullWidthBelowMid = !1, this.isLoading = !1, this.isOpen = !1, this.position = "center", this.size = "medium", this._backButtonClicked = !1, this._handleDialogCancelEvent = (e) => {
      this.isDismissible || e.preventDefault();
    }, this._handleDialogLightDismiss = (e) => {
      var b;
      if (!this.isDismissible)
        return;
      const i = (b = this._dialog) == null ? void 0 : b.getBoundingClientRect(), {
        top: t = 0,
        bottom: o = 0,
        left: r = 0,
        right: c = 0
      } = i || {};
      if (t === 0 && o === 0 && r === 0 && c === 0)
        return;
      (e.clientY < t || e.clientY > o || e.clientX < r || e.clientX > c) && (this.isOpen = !1);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", (e) => this._handleDialogLightDismiss(e)), document.addEventListener(k, (e) => this._handleModalOpened(e)), document.addEventListener(_, (e) => this._handleModalClosed(e)), document.addEventListener(z, (e) => this._handleModalClosed(e));
  }
  disconnectedCallback() {
    document.removeEventListener(k, (e) => this._handleModalOpened(e)), document.removeEventListener(_, (e) => this._handleModalClosed(e)), document.removeEventListener(z, (e) => this._handleModalClosed(e)), super.disconnectedCallback();
  }
  async firstUpdated(e) {
    super.firstUpdated(e), this._dialog && ((await import("./dialog-polyfill.esm-209f54f8.js").then((t) => t.default)).registerDialog(this._dialog), this._dialog.addEventListener("cancel", (t) => this._handleDialogCancelEvent(t)), this._dialog.addEventListener("close", () => {
      this.isOpen = !1;
    })), this._handleModalOpenStateOnFirstRender(e);
  }
  updated(e) {
    super.updated(e), this._handleModalOpenStateChanged(e);
  }
  /**
   * Opens the dialog element and disables page scrolling
   */
  _handleModalOpened(e) {
    var t, o, r, c;
    const { targetModal: i } = e.detail;
    if (i === this) {
      const p = (t = this._dialog) == null ? void 0 : t.querySelector(".c-modal-scrollContainer");
      if (p && ("scrollTo" in window && window.scrollTo(0, 0), K(p)), (o = this._dialog) != null && o.hasAttribute("open") || !((r = this._dialog) != null && r.isConnected))
        return;
      (c = this._dialog) == null || c.showModal();
    }
  }
  /**
   * Closes the dialog element and re-enables page scrolling
   */
  _handleModalClosed(e) {
    var t, o;
    const { targetModal: i } = e.detail;
    if (i === this) {
      const r = (t = this._dialog) == null ? void 0 : t.querySelector(".c-modal-scrollContainer");
      r && G(r), (o = this._dialog) == null || o.close(), this._returnFocus();
    }
  }
  // Handles the value of the isOpen property on first render of the component
  _handleModalOpenStateOnFirstRender(e) {
    e.get("isOpen") === void 0 && this.isOpen && h(this, k, { targetModal: this });
  }
  // Handles changes to the modal isOpen property by dispatching any appropriate events
  _handleModalOpenStateChanged(e) {
    const i = e.get("isOpen");
    i !== void 0 && (i ? this._backButtonClicked ? (this._backButtonClicked = !1, h(this, z, { targetModal: this })) : h(this, _, { targetModal: this }) : h(this, k, { targetModal: this }));
  }
  _handleActionClick(e) {
    var i, t;
    e === "leading" ? ((i = this._dialog) == null || i.close("leading"), h(this, ee, { targetModal: this })) : e === "supporting" && ((t = this._dialog) == null || t.close("supporting"), h(this, ie, { targetModal: this }));
  }
  /**
   * Return focus to the specified element, providing the selector is valid
   * and the chosen element can be found.
   */
  _returnFocus() {
    var i, t;
    const e = (i = this.returnFocusAfterCloseSelector) == null ? void 0 : i.trim();
    e && ((t = document.querySelector(e)) == null || t.focus());
  }
  /**
   * Template for the close button element. Called within the
   * main render function.
   *
   * @private
   */
  renderCloseButton() {
    var e;
    return m`
            <pie-icon-button
                @click="${() => {
      this.isOpen = !1;
    }}"
                variant="ghost-secondary"
                class="c-modal-closeBtn"
                aria-label="${((e = this.aria) == null ? void 0 : e.close) || s}"
                data-test-id="modal-close-button">
                <icon-close></icon-close>
            </pie-icon-button>`;
  }
  /**
   * Template for the back button element. Called within the
   * main render function.
   *
   * @private
   */
  renderBackButton() {
    var e;
    return m`
            <pie-icon-button
                @click="${() => {
      this._backButtonClicked = !0, this.isOpen = !1;
    }}"
                variant="ghost-secondary"
                class="c-modal-backBtn"
                aria-label="${((e = this.aria) == null ? void 0 : e.back) || s}"
                data-test-id="modal-back-button">
                ${this.isRTL ? m`<icon-chevron-right></icon-chevron-right>` : m`<icon-chevron-left></icon-chevron-left>`}
            </pie-icon-button>
        `;
  }
  /**
   * Render leadingAction button depending on prop availability.
   *
   * 1. If the prop `leadingAction` is not provided, the button is not rendered.
   * 2. If the prop `leadingAction` is provided but any of the optional properties
   * are not provided, they fall back to their default values.
   *
   * @private
   */
  renderLeadingAction() {
    const { text: e, variant: i = "primary", ariaLabel: t } = this.leadingAction;
    return e ? m`
            <pie-button
                variant="${i}"
                aria-label="${t || s}"
                type="submit"
                ?isFullWidth="${this.hasStackedActions}"
                @click="${() => this._handleActionClick("leading")}"
                data-test-id="modal-leading-action">
                ${e}
            </pie-button>
        ` : s;
  }
  /**
   * Render supportingAction button depending on prop availability.
   *
   * 1. If the prop `supportingAction` is not provided, the button is not rendered.
   * 2. If the prop `supportingAction` is provided but any of the optional properties
   * are not provided, they fall back to their default values.
   * 3. If `supportingAction` is provided but not `leadingAction`, log a warning and do
   * not render `supportingAction`.
   *
   * @private
   */
  renderSupportingAction() {
    const { text: e, variant: i = "ghost", ariaLabel: t } = this.supportingAction;
    return e ? this.leadingAction ? m`
            <pie-button
                variant="${i}"
                aria-label="${t || s}"
                type="reset"
                ?isFullWidth="${this.hasStackedActions}"
                @click="${() => this._handleActionClick("supporting")}"
                data-test-id="modal-supporting-action">
                ${e}
            </pie-button>
        ` : (console.warn("Use `leadingAction` instead of `supportingAction`. `supportingAction` is being ignored."), s) : s;
  }
  /**
   * Renders the modal inner content and footer of the modal.
   * @private
   */
  renderModalContentAndFooter() {
    return m`
        <article class="c-modal-scrollContainer c-modal-content c-modal-content--scrollable">
            <div class="c-modal-contentInner"
            data-test-id="modal-content-inner">
                <slot></slot>
            </div>
            ${this.isLoading ? m`<pie-spinner size="xlarge" variant="secondary"></pie-spinner>` : s}
        </article>
        <footer class="c-modal-footer">
            ${this.leadingAction ? this.renderLeadingAction() : s}
            ${this.supportingAction ? this.renderSupportingAction() : s}
        </footer>`;
  }
  render() {
    const {
      aria: e,
      hasBackButton: i,
      hasStackedActions: t,
      heading: o,
      headingLevel: r = "h2",
      isDismissible: c,
      isFooterPinned: p,
      isFullWidthBelowMid: b,
      isLoading: x,
      leadingAction: $,
      position: D,
      size: E,
      supportingAction: T
    } = this, A = N(r);
    return m`
        <dialog
            id="dialog"
            class="c-modal"
            size="${E || "medium"}"
            position="${D || "center"}"
            ?hasActions=${$ || T}
            ?hasBackButton=${i}
            ?hasStackedActions=${t}
            ?isDismissible=${c}
            ?isFooterPinned=${p}
            ?isFullWidthBelowMid=${b}
            ?isLoading=${x}
            aria-busy="${x ? "true" : "false"}"
            aria-label="${x && (e == null ? void 0 : e.loading) || s}"
            data-test-id="pie-modal">
            <header class="c-modal-header"
            data-test-id="modal-header">
                ${i ? this.renderBackButton() : s}
                <${A} class="c-modal-heading">
                    ${o}
                </${A}>
                ${c ? this.renderCloseButton() : s}
            </header>
            ${// We need to wrap the remaining content in a shared scrollable container if the footer is not pinned
    p ? this.renderModalContentAndFooter() : m`
                        <div class="c-modal-scrollContainer">
                            ${this.renderModalContentAndFooter()}
                        </div>
                        `}
        </dialog>`;
  }
}
a.styles = F(X);
l([
  d({ type: Object })
], a.prototype, "aria", 2);
l([
  d({ type: String }),
  j(v)
], a.prototype, "heading", 2);
l([
  d(),
  C(v, J, "h2")
], a.prototype, "headingLevel", 2);
l([
  d({ type: Boolean })
], a.prototype, "hasBackButton", 2);
l([
  d({ type: Boolean })
], a.prototype, "hasStackedActions", 2);
l([
  d({ type: Boolean, reflect: !0 })
], a.prototype, "isDismissible", 2);
l([
  d({ type: Boolean })
], a.prototype, "isFooterPinned", 2);
l([
  d({ type: Boolean })
], a.prototype, "isFullWidthBelowMid", 2);
l([
  d({ type: Boolean, reflect: !0 })
], a.prototype, "isLoading", 2);
l([
  d({ type: Boolean })
], a.prototype, "isOpen", 2);
l([
  d({ type: Object })
], a.prototype, "leadingAction", 2);
l([
  d(),
  C(v, Z, "center")
], a.prototype, "position", 2);
l([
  d()
], a.prototype, "returnFocusAfterCloseSelector", 2);
l([
  d(),
  C(v, Q, "medium")
], a.prototype, "size", 2);
l([
  d({ type: Object })
], a.prototype, "supportingAction", 2);
l([
  I("dialog")
], a.prototype, "_dialog", 2);
W(v, a);
export {
  z as ON_MODAL_BACK_EVENT,
  _ as ON_MODAL_CLOSE_EVENT,
  ee as ON_MODAL_LEADING_ACTION_CLICK,
  k as ON_MODAL_OPEN_EVENT,
  ie as ON_MODAL_SUPPORTING_ACTION_CLICK,
  a as PieModal,
  J as headingLevels,
  Z as positions,
  Q as sizes
};
